import { render, staticRenderFns } from "./PopChatAdditionalVendor.vue?vue&type=template&id=46905435&lang=pug"
import script from "./PopChatAdditionalVendor.vue?vue&type=script&lang=js"
export * from "./PopChatAdditionalVendor.vue?vue&type=script&lang=js"
import style0 from "./PopChatAdditionalVendor.vue?vue&type=style&index=0&id=46905435&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports